import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DialogModule } from 'primeng/dialog';
import { AutoCompleteModule } from 'primeng/autocomplete';


import { PrimeDialogComponent } from './components/prime-dialog/prime-dialog.component';


@NgModule({
  declarations: [
    PrimeDialogComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    AutoCompleteModule
  ],
  exports: [
    PrimeDialogComponent,

    AutoCompleteModule
  ]
})
export class PrimeNgModule { }
